(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(productRecommendationsSection);
  
  const url = productRecommendationsSection.dataset.url;
  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');
      
      if (recommendations && recommendations.innerHTML.trim().length) {
        const productsGrid = recommendations.querySelector('.grid-products');
        if (productsGrid && productsGrid.children.length > 0) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        } else {
          productRecommendationsSection.remove();
        }
      } else {
        productRecommendationsSection.remove();
      }
    })
    .catch(e => {
      console.error('Error loading complementary products:', e);
      productRecommendationsSection.remove();
    });
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
if (productRecommendationsSection) {
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 400px 0px'});
  observer.observe(productRecommendationsSection);
}

  } catch(e) { console.error(e); }
})();
})();
